import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { currentUserBaseNode } from "../../redux/organization/selectors";
import { IAppState } from "../../redux/types";
import { usePathToNode } from "../../utils/hooks/hooks";
import AvaliableNodeSelect from "./AvaliableNodeSelect";

const NodeSelect = ({
  onSave,
}: {
  onSave: (newNodeId: number) => void;
}): JSX.Element => {
  const { t } = useTranslation("comon");
  const selectedNode = useSelector(
    (state: IAppState) => state.userProfile.monitorNodeId
  );
  const selectedNodePath = usePathToNode(selectedNode);

  const userBaseNode = useSelector(currentUserBaseNode);
  const userBaseNodePath = usePathToNode(userBaseNode);

  const [targetNodeId, setTargetNode] = useState(0);
  const [active, setActive] = useState(false);
  const onNodeSelect = useCallback(
    (value) => {
      if (value !== 0) setTargetNode(value);
      else {
        if (userBaseNodePath.length === 0)
          //&& filteringType !== NodeFilteringState.END_NODE)
          setTargetNode(userBaseNode);
      }
    },
    [userBaseNode, userBaseNodePath]
  );

  const selectDepart = (state: boolean) => {
    setActive(state);
  };

  console.log(active);

  return (
    <div
      className="select-node-view"
      style={{
        alignItems: "center",
        justifyContent: `${!active ? "center" : ""}`,
      }}
    >
      <AvaliableNodeSelect
        selectedNodePath={selectedNodePath}
        prohibitToChooseBuildings={userBaseNodePath.length > 1}
        selectNode={onNodeSelect}
        strictToNode={selectedNodePath?.length > 0}
        includeAllBuildings={false}
        includeAllDepartments={userBaseNodePath.length <= 1}
        includeAllGroups={userBaseNodePath.length <= 2}
        baseNodePath={userBaseNodePath}
        selectDepart={selectDepart}
      />
      <button
        className="btn secondary save-view"
        onClick={() => onSave(targetNodeId)}
        style={{ marginTop: "20px" }}
      >
        {t("buttons.Save")}
      </button>
    </div>
  );
};

export default React.memo(NodeSelect);
